import React from 'react';
import Preloader from '@omilia/preloader';

import Splitter from '../Splitter';
import Files from './components/Files';

import './style.scss';

const Editor = React.lazy(() =>
  import(/* webpackChunkName: "Editor" */ './components/Editor'),
);

const FileSystem = props => {
  const {
    count,
    currentPage,
    hasNameExceptions,
    modelName,
    listItems,
    isLoadingList,
    isUploading,
    uploadingFilesList,
    hasUploadingFilesError,
    listSearchTerm,
    sidebarIsOpen,
    getFiles,
    addNewFile,
    addFile,
    updateFile,
    updatedSearchTerm,
    openFile,
    uploadFiles,
    resetUploadFiles,
    deleteFiles,
    exportFiles,
    deleteFile,
    exportFile,
    openFiles,
    project,
    projectIsLoading,
    location,
    lastLocation,
    isLoadingEditor,
    isSaving,
    theme,
    editorSearchTerm,
    selectedFile,
    selectedFiles,
    closeEditorFile,
    setTheme,
    updateEditorSearchTerm,
    updateBlob,
    updateFiles,
    // This extra prop is used only when for flow view because editor should be
    // loaded only when export request is finished
    // TODO: remove this prop and make the export request at Flow view after
    // refactoring Bounder
    shouldLoadEditor = true,
  } = props;

  return (
    <div styleName="flow">
      <Splitter split="vertical">
        <Files
          addFile={addFile}
          addNewFile={addNewFile}
          count={count}
          currentPage={currentPage}
          deleteFile={deleteFile}
          deleteFiles={deleteFiles}
          exportFile={exportFile}
          exportFiles={exportFiles}
          getFiles={getFiles}
          hasNameExceptions={hasNameExceptions}
          hasUploadingFilesError={hasUploadingFilesError}
          isLoading={isLoadingList}
          isUploading={isUploading}
          items={listItems}
          lastLocation={lastLocation}
          location={location}
          modelName={modelName}
          openFile={openFile}
          openFiles={openFiles}
          project={project}
          projectIsLoading={projectIsLoading}
          resetUploadFiles={resetUploadFiles}
          searchTerm={listSearchTerm}
          sidebarIsOpen={sidebarIsOpen}
          updatedSearchTerm={updatedSearchTerm}
          updateFile={updateFile}
          uploadFiles={uploadFiles}
          uploadingFilesList={uploadingFilesList}
        />

        <React.Suspense fallback={<Preloader />}>
          <Editor
            closeEditorFile={closeEditorFile}
            isLoading={isLoadingEditor}
            isSaving={isSaving}
            openFile={openFile}
            searchTerm={editorSearchTerm}
            selectedFile={selectedFile}
            selectedFiles={selectedFiles}
            setTheme={setTheme}
            shouldLoadEditor={shouldLoadEditor}
            theme={theme}
            updateBlob={updateBlob}
            updateEditorSearchTerm={updateEditorSearchTerm}
            updateFiles={updateFiles}
          />
        </React.Suspense>
      </Splitter>
    </div>
  );
};

FileSystem.propTypes = {
  ...Files.propTypes,
  ...Editor.propTypes,
};

export default FileSystem;
